// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-01ea64c8]{height:calc(100% - 260px)}.inpustyle[data-v-01ea64c8]{width:400px}.addbut[data-v-01ea64c8]{margin-left:20px}.headebut[data-v-01ea64c8]{width:100%;margin-bottom:20px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
